import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

const getResourceUrl = () => `${PREFIX.vapis_v1_dc_ws(GROUPS.clusterScheduler)}/resource-configurations`;

export interface GetComputeResourceConfigurationsParams {
  workloadType: string;
  resourceType: string;
  /** GPU 清单查询时按架构过滤 */
  architecture?: string;
}

export function getComputeResourceConfigurations(params: GetComputeResourceConfigurationsParams) {
  return get<unknown[]>(getResourceUrl(), { ...(params || {}), availability: true });
}

export function getComputeResourceLimit(namespace: string, name: string, params?: Record<string, unknown>) {
  const url = `${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/namespaces/${namespace}/virtualmachines/${name}/resource-limit`;
  return get<Record<string, { cpu?: number; memory?: string }>>(url, params);
}
